import { render, staticRenderFns } from "./back.vue?vue&type=template&id=6489a64b&scoped=true&"
import script from "./back.vue?vue&type=script&lang=js&"
export * from "./back.vue?vue&type=script&lang=js&"
import style0 from "./back.vue?vue&type=style&index=0&id=6489a64b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6489a64b",
  null
  
)

export default component.exports